import { render } from "./WrapV1.1.vue?vue&type=template&id=acc2ffdc&scoped=true"
import script from "./WrapV1.1.vue?vue&type=script&lang=js"
export * from "./WrapV1.1.vue?vue&type=script&lang=js"

import "./WrapV1.1.vue?vue&type=style&index=0&id=acc2ffdc&lang=scss"
import "./WrapV1.1.vue?vue&type=style&index=1&id=acc2ffdc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acc2ffdc"]])

export default __exports__